(function() {
	'use strict';

	angular.module('quantixApp').factory('masterService',
			masterService);

	masterService.$inject = [ '$http', '$q' ];

	function masterService($http, $q) {
		
	
		  var _getListByName = function(searchText) {

				var deferred = $q.defer();

				var url = 'api/navbar/getList';
//				var url= 'api/industryProfile/getIndustries';
				$http.post(url, {searchText : searchText} ,{ignoreLoadingBar: true }).then(function(response) {
					deferred.resolve(response);

				}, function(errResponse) {
					deferred.reject(errResponse);
				});

				return deferred.promise;
			}


			var _getListByCompIndCode = function(compIndCode) {

				var deferred = $q.defer();

				var url = 'api/navbar/getListByCompIndCode';
//				var url= 'api/industryProfile/getIndustries';
				$http.post(url, {compIndCode : compIndCode} ,{ignoreLoadingBar: true }).then(function(response) {
					deferred.resolve(response);

				}, function(errResponse) {
					deferred.reject(errResponse);
				});

				return deferred.promise;
			}

		  
	
		return {
			
			getListName : _getListByName,
			getListCompIndCode : _getListByCompIndCode
		};
	}
})();
